import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import Pages from "@client.enums/pages";
import "./LeftSideBar.scss";

const LeftSideBar = () => {
  const { t } = useTranslation();

  const links = [
    {
      url: Pages.ReportsCompany,
      name: "components.Reports.LeftSideBar.company",
      disabled: false,
    },
    {
      url: Pages.ReportsParticipants,
      name: "components.Reports.LeftSideBar.participants",
      disabled: false,
    },
    {
      url: Pages.ReportsMeetings,
      name: "components.Reports.LeftSideBar.meetings",
      disabled: false,
    },
    {
      url: Pages.ReportsComparisons,
      name: "components.Reports.LeftSideBar.comparisons",
      disabled: true,
    },
    {
      url: Pages.ReportsTrends,
      name: "components.Reports.LeftSideBar.trends",
      disabled: true,
    },
    {
      url: Pages.ReportsCost,
      name: "components.Reports.LeftSideBar.cost",
      disabled: true,
    },
  ];
  return (
    <div className="left-side-bar">
      {links.map((link) => {
        const name = t(link.name);
        return link.disabled ? (
          <span className="disabled-link" key={link.url}>
            {name}
          </span>
        ) : (
          <NavLink
            key={link.url}
            to={link.url}
            title={name}
            className={(navData) => {
              return classNames({ active: navData.isActive });
            }}
          >
            {name}
          </NavLink>
        );
      })}
    </div>
  );
};

export default LeftSideBar;
